import { AxiosError } from "axios";
import { StatusCodes } from "http-status-codes";

const STATUS_MESSAGES: Record<number, string> = {
  [StatusCodes.BAD_REQUEST]:
    "There was a problem with your request. Please fix the errors and try again.",
  [StatusCodes.UNAUTHORIZED]:
    "You are not logged in or your session has expired. Please log in again.",
  [StatusCodes.FORBIDDEN]: "You do not have permission to perform this action.",
  [StatusCodes.NOT_FOUND]: "The requested resource was not found.",
  [StatusCodes.CONFLICT]: "There was a conflict with your request.",
  [StatusCodes.TOO_MANY_REQUESTS]:
    "You have made too many requests in a short period of time. Please try again later.",
};
const internalErrorMessage =
  "An unknown problem occurred. Please try again or contact support.";

export class ApiError extends Error {
  constructor(axiosError: AxiosError) {
    const status = axiosError.response?.status ?? 500;
    const message =
      status in STATUS_MESSAGES
        ? STATUS_MESSAGES[status]
        : internalErrorMessage;
    super(message);
    this.name = "ApiError";
    this.cause = axiosError;
  }
}

export function isRetryableError(error: Error): boolean {
  if (!(error instanceof ApiError) || !(error.cause instanceof AxiosError)) {
    return true;
  }
  const status = error.cause.response?.status;
  return !status || status >= 500;
}
